/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrganizationMessagingCountsResource } from '../models/OrganizationMessagingCountsResource'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class OrganizationsMessagingService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getOrganizationMessagingCounts({
        organization
    }: {
        /**
         * Organization ID
         */
        organization: number
    }): CancelablePromise<{
        data: OrganizationMessagingCountsResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organization}/messaging-counts',
            path: {
                organization: organization
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
